import { LANDING } from '@/constants/testIds';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  return (
    <section
      id="hero"
      data-testid={LANDING.heroSection}
      className="relative min-h-[90vh] flex items-center overflow-hidden"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/10340273/pexels-photo-10340273.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-void via-void/95 to-void/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-void via-transparent to-void/50" />
      </div>

      {/* Subtle scan line */}
      <div className="absolute inset-0 z-[1] pointer-events-none overflow-hidden">
        <div className="scan-line" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-32 pb-24">
        <div className="max-w-3xl">
          {/* Gold accent line */}
          <div className="w-12 h-px bg-signal-gold mb-8 opacity-0 animate-fade-up" style={{ animationDelay: '0.05s' }} />

          <p className="font-mono text-signal-gold text-xs tracking-widest uppercase mb-8 opacity-0 animate-fade-up" style={{ animationDelay: '0.1s' }}>
            Athletic Vision Training
          </p>

          <h1
            data-testid={LANDING.heroHeadline}
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold text-bone tracking-tight leading-[1.1] opacity-0 animate-fade-up"
            style={{ animationDelay: '0.25s' }}
          >
            Vision is the unfair advantage no one trains.
          </h1>

          <p
            data-testid={LANDING.heroSubtext}
            className="font-body text-slate text-base md:text-lg max-w-2xl mt-8 leading-relaxed opacity-0 animate-fade-up"
            style={{ animationDelay: '0.45s' }}
          >
            Every other system — strength, speed, skill — gets a program. Vision gets a pair of glasses and a hope. VisIQ exists to close that gap: it is the dashboard for the sense that runs every other sense.
          </p>

          <div className="mt-12 opacity-0 animate-fade-up" style={{ animationDelay: '0.6s' }}>
            <a
              data-testid={LANDING.heroCtaBtn}
              href="https://app.visiq.es"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-bone text-void font-body font-medium px-8 py-4 rounded-none hover:bg-signal-gold transition-colors duration-300 group"
            >
              Get started
              <ArrowRight size={18} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
